import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Pagination from "./Pagination";
import constants from "../../constants";
import { getDataFromStorage } from "../../util";
import TestSvgIcon from "../../Svg/TestSvgIcon";
import WarningSvgIcon from "../../Svg/WarningSvgIcon";
import Typography from "@mui/material/Typography";
import React, { useContext, useState } from "react";
import TestDueHooks from "../../Hooks/TestDueHooks";
import AlertContext from "../../context/AlertContext";
import Tooltip from "./Tooltip";

export default function AssignmentDue(Props) {
  const { setTestData } = useContext(AlertContext);
  const { currentDueLabel, getDayDifference } = TestDueHooks();

  // Pagination control

  const itemsPerPage = 3;
  const [currentPage, setCurrentPage] = useState(1);

  // Calculate the index range for the current page

  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;

  // Get the current page's events

  const currentEvents = Props.dueList?.slice(startIndex, endIndex);

  // Total number of pages

  const totalPages = Math.ceil(Props.dueList?.length / itemsPerPage);

  // Handle pagination click

  const handlePaginationClick = (pageIndex) => {
    setCurrentPage(pageIndex);
  };

  const showDateonly = (dateString) => {
    const date = new Date(dateString);
    const formattedDate = date.toLocaleDateString();

    return formattedDate;
  };

  const AssignmentStatusBox = ({ data }) => {
    const dayDifference = getDayDifference(data?.dueDate, data?.assignedDate);

    const isDue = dayDifference <= 0;

    return (
      <Box className="assignment-due-container-assignment-status-box">
        <div
          className={
            currentDueLabel(data.dueDate) === "Past Due"
              ? "div-PastDue"
              : currentDueLabel(data.dueDate) === "Due Today"
              ? "div-DueToday"
              : "div-NoDue"
          }
          onClick={() => {
            if (getDataFromStorage("role") !== constants.Roles.parent) {
              setTestData({
                testId: data.id,
                pathName: "dashBoard",
                moduleId: data.moduleId,
                parentModId: data.parentmodId,
              });
              Props.naviageHomeFunction(data.lpId, "dashBoard");
            }
          }}
        >
          {Props.from === "SelfBatch" || Props.from === "LearningBatch"
            ? showDateonly(data.dueDate)
            : currentDueLabel(data.dueDate)}
        </div>

        {Props.from === "SelfBatch" && (
          <WarningSvgIcon
            component="codingTable"
            due={isDue ? "Due Today" : ""}
          />
        )}
      </Box>
    );
  };

  return (
    <Box
      className={`assignment-due-box-div ${
        parseInt(localStorage.getItem("batchType")) ===
        constants.BATCH_TYPE.SELF
          ? "singlebox"
          : ""
      }`}
    >
      {Props.from !== "SelfBatch" && (
        <Typography className="assignment-due-box-header" gutterBottom>
          Assignments Due
        </Typography>
      )}
      {(
        Props.from === "SelfBatch"
          ? Props.dueList?.length > 0
          : currentEvents?.length > 0
      ) ? (
        <>
          <Box
            height={Props.from !== "SelfBatch" ? 170 : 64}
            className="assignment-due-container"
          >
            {(Props.from === "SelfBatch" ? Props.dueList : currentEvents)?.map(
              (data, index) => (
                <Grid
                  container
                  key={index}
                  className="assignment-due-container-div"
                >
                  <Box className="assignment-due-container-icon">
                    <TestSvgIcon
                      libType={data.libType}
                      component={
                        Props.from !== "SelfBatch"
                          ? "learnerDashBoard"
                          : undefined
                      }
                      active={Props.from === "SelfBatch"}
                    />
                  </Box>
                  <Grid className="assignment-due-container-assignment-detail">
                    <Box className="assignment-due-container-assignment-detail-box">
                      <Tooltip title={data.name} placement="bottom">
                        <Typography className="assignment-due-container-assignment-name">
                          {data.name}
                        </Typography>
                      </Tooltip>
                      {Props.from !== "LearningBatch" &&
                        (Props.from !== "SelfBatch" ? (
                          <Typography className="assignment-due-container-assignment-detail-date">
                            {data.lpName} .{" "}
                            {parseInt(localStorage.getItem("batchType")) !==
                              constants.BATCH_TYPE.SELF &&
                              "Assigned on " + showDateonly(data.assignedDate)}
                          </Typography>
                        ) : (
                          <AssignmentStatusBox data={data} />
                        ))}
                    </Box>
                  </Grid>
                  {Props.from !== "SelfBatch" &&
                    Props.from !== "LearningBatch" && (
                      <Box className="assignment-due-container-assignment-status-box">
                        <div
                          className={
                            currentDueLabel(data.dueDate) === "Past Due"
                              ? parseInt(localStorage.getItem("batchType")) ===
                                constants.BATCH_TYPE.SELF
                                ? "div-Due"
                                : "div-PastDue"
                              : currentDueLabel(data.dueDate) === "Due Today"
                              ? "div-DueToday"
                              : "div-NoDue"
                          }
                          onClick={() => {
                            if (
                              getDataFromStorage("role") !==
                              constants.Roles.parent
                            ) {
                              setTestData({
                                testId: data.id,
                                pathName: "dashBoard",
                                moduleId: data.moduleId,
                                parentModId: data.parentmodId,
                              });

                              Props.naviageHomeFunction(data.lpId, "dashBoard");
                            }
                          }}
                        >
                          {currentDueLabel(data.dueDate) === "Past Due" ||
                          (currentDueLabel(data.dueDate) === "Due Today" &&
                            parseInt(localStorage.getItem("batchType")) ===
                              constants.BATCH_TYPE.SELF)
                            ? "Due"
                            : currentDueLabel(data.dueDate)}
                        </div>
                      </Box>
                    )}
                </Grid>
              )
            )}
          </Box>
          {Props.from !== "SelfBatch" && (
            <Box className="assignment-due-pagination-box">
              <Pagination
                totalPages={totalPages}
                currentPage={currentPage}
                onPageChange={handlePaginationClick}
              />
            </Box>
          )}
        </>
      ) : (
        <>
          <Box className="assignment-due-empty-container">
            <div>
              No Assignment due
              <div>You can focus on your learning path now</div>
            </div>
          </Box>
        </>
      )}
    </Box>
  );
}
